export default __webpack_public_path__ + "static/footer-no-bg-9b408848142f9455d68057ab16ef0804.png";